import { createSlice } from '@reduxjs/toolkit'
import {
  clientSettingsReducerConfig,
  initialClientSettingsState,
} from '@gocanvas/client/dist/store/reducers/clientSettings/index.jsx'

const fetchClientSetting = setting => {
  const clientSettings = window.configAttachment || {}
  return clientSettings[setting]
}

export const initialState = {
  ...initialClientSettingsState,
  fileSizeLimit:
    fetchClientSetting('file_size_limit') ||
    initialClientSettingsState.fileSizeLimit,
  clientType: 'builder',
  prePopulationLimit: 150,
  undoEnabled: true,
}

export const clientSettingsSliceConfig = {
  name: 'clientSettings',
  initialState: initialState,
  reducers: clientSettingsReducerConfig,
}

const clientSettingsSlice = createSlice(clientSettingsSliceConfig)
export const {
  actions: clientSettingsActions,
  reducer: clientSettingsReducer,
} = clientSettingsSlice
